import styled from '@emotion/styled';

type Props = {
  'data-test'?: string;
};

const Thumbnail = styled('img')<Props>({
  borderRadius: '50%',
  display: 'block',
  float: 'left',
  height: '4rem',
  marginRight: '1rem',
  width: '4rem',
});

export default Thumbnail;
